import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconFill, StyleguideModule } from '@woolworthsnz/styleguide';

@Component({
	selector: 'store-locator-pin-with-number',
	template: `
		<cdx-svg-icon name="location-pin-a" [fill]="fill"></cdx-svg-icon>
		<p [attr.aria-label]="(label | ordinal) + ' store'">{{ label }}</p>
	`,
	styleUrls: ['./pin-with-number.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [StyleguideModule]
})
export class PinWithNumberComponent {
	@Input() label: number;
	@Input() fill: IconFill;
}
